<!--
 * @Author: luohongbiao
 * @Date: 2022-01-05 10:07:24
 * @LastEditTime: 2022-07-23 09:58:59
 * @LastEditors: LHB
 * @Description: 
 * @FilePath: \shirleyClass\src\modules\Express\index.vue
-->
<template>
  <div class="wrap">
    <div class="expressBox">
      <!-- 头部 -->
      <div class="header">
        <div class="box-content">
          <div class="content-top">
            <div class="content-left">
              <img class="giftImg" :src="pic" alt="" />
            </div>
            <div class="content-right">
              <div class="right-top item-title">{{ itemName }}</div>
              <div class="right-bottom item-subtitle">
                {{ skuName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 物流列表 -->
      <div v-if="exPressData && exPressData.length" class="express-box">
        <div
          class="newListBox"
          v-for="(item, index) in exPressData"
          :key="index"
        >
          <div class="expressStateBox">
            <div class="stateBox">
              <div v-if="item.title" class="packageTitle">{{ item.title }}</div>
              <div class="stateInfo">
                <div class="statetitle">
                  发货状态：
                  <span
                    class="sendState"
                    style="color: #ee0a24"
                    v-if="item.status == 'PRE_DELIVERY'"
                    >待发货</span
                  >
                  <span
                    class="sendState"
                    style="color: #ed6a0c"
                    v-else-if="item.status == 'DELIVERY'"
                    >已发货</span
                  >
                  <span
                    class="sendState"
                    style="color: #ee0a24"
                    v-if="item.status == 'SIGN'"
                    >已签收</span
                  >
                </div>
                <div class="statetitle">
                  物流公司：{{
                    item.logisticsName ? item.logisticsName : '暂无'
                  }}
                </div>
                <div class="statetitle">
                  运单编号：{{ item.expressCode ? item.expressCode : '暂无' }}
                </div>
              </div>
            </div>
            <div
              class="setpBox"
              v-if="item && item.processes && item.processes.length"
            >
              <van-steps
                direction="vertical"
                :active="item.processes.length - 1"
                active-color="#EE0A24"
              >
                <van-step v-for="(item1, index) in item.processes" :key="index">
                  <div class="no-active-city">{{ item1.operateContent }}</div>
                  <div class="no-active-date">{{ item1.operateTime }}</div>
                </van-step>
              </van-steps>
            </div>
            <div class="setpBox setpBoxNone" v-else>
              <img
                class="emptyImg"
                src="../../assets/images/empty_img_wuliu.png"
                alt=""
              />
              <div class="emptyTitle">暂无物流信息</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="box empety">
          <img
            class="emptyImg"
            src="../../assets/images/empty_img_wuliu.png"
            alt=""
          />
          <div class="emptyTitle">暂无物流信息</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from '../../utils/index.js'
import tools from '../common/tools.js'
import wx_tools from '../common/wx_tools.js'
import group from '../common/group.js'

import testimg from '../../assets/images/my_lock_icon@2x.png'

export default {
  name: 'express',
  components: {},
  data() {
    return {
      id: '', //订单编号
      orderId: '',
      token: '',
      tokenKey: 'tokenKey',
      exPressData: {},
      pic: testimg,
      itemName: '',
      skuName: ''
    }
  },
  mounted() {
    document.title = '物流查询'
    this.token = localStorage.getItem(this.tokenKey)

    this.orderId = this.$route.query.orderId
    // // 需要把上页的头图传过来
    this.pic = this.$route.query.pic
    this.itemName = this.$route.query.itemName
    this.skuName = this.$route.query.skuName
    console.log('物流参数', this.orderId, this.token)
    this.getDelivery()
    this.initShare()
  },
  methods: {
    getDelivery() {
      let params = {
        orderId: this.orderId,
        token: this.token
      }
      utils.tools.showLoading()
      group.delivery
        .call(this, params)
        .then((res) => {
          utils.tools.hideLoading()
          console.log('物流', res)
          if (res.data.success) {
            this.exPressData = res.data.data || []
          } else {
            this.$toast(res.data.error.msg)
          }
          console.log('物流1', this.exPressData)
        })
        .catch((error) => {
          utils.tools.hideLoading()
          console.log(error)
        })
    },
    initShare() {
      console.log('调用initShare')
      const tempJumpLink = utils.config.config.shareUrl
      // 分享字数规则：主标题两行，副标题3行，超出全部...
      let shareObj = {
        debug: false,
        referer: tempJumpLink,
        appId: utils.config.config.appId,
        title: utils.config.config.shareMainTitle,
        desc: utils.config.config.shareDesTitle,
        link: tempJumpLink,
        imgUrl: utils.config.config.shareImgUrl,
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
        // success: this.shareSuccess
        // fail: this.shareFail
      }
      console.log('分享跳转地址--login', shareObj)
      wx_tools.initShare.call(this, shareObj)
    }
  }
}
</script>

<style src="./index.css" scoped></style>
<style>
.van-step__title {
}
.van-step__title--active .no-active-city {
  color: #ee0a24 !important;
  font-size: 0.4rem;
  font-weight: 400;
}
.van-step__title--active .no-active-date {
  color: #ee0a24 !important;
}
</style>
